/* eslint-disable max-len */
import React from 'react';
function YearViewOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 20V5C21 3.9 20.1 3 19 3H18V2H16V3H8V2H6V3H5C3.89 3 3.01 3.9 3.01 5L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20ZM19 5V20H5V5H19ZM17 9V7H15V9H17ZM13 9H11V7H13V9ZM9 10V12H7V10H9ZM17 10V12H15V10H17ZM11 12H13V10H11V12ZM9 15V13H7V15H9ZM17 15V13H15V15H17ZM13 15H11V13H13V15ZM9 16V18H7V16H9ZM17 16V18H15V16H17ZM11 18H13V16H11V18ZM9 7H7V9H9V7Z" })));
}
export default YearViewOutlined;
